import script from "./GlobalHeader.vue?vue&type=script&setup=true&lang=ts"
export * from "./GlobalHeader.vue?vue&type=script&setup=true&lang=ts"

import "./GlobalHeader.vue?vue&type=style&index=0&id=3b9748c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3b9748c2"]])

export default __exports__